package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.tse_location


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)